import { useCallback, useState } from 'react'

import { useParams } from 'react-router'

import { type IBreadcrumbsProps } from '@webapp/core/components/Breadcrumbs'
import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { ExpenseView } from '@webapp/modules/expense/feature-sets/ExpenseView'
import messages from './messages'

export const ExpenseDetailPage = () => {
  const { uuid } = useParams<{ uuid: string }>()
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  const [canApprove, setCanApprove] = useState(false)

  const handlePermissionsLoaded = useCallback(
    ({ canApprove: loaded }: { canApprove: boolean }) => {
      setCanApprove(loaded)
    },
    []
  )

  const breadcrumbs = (
    canApprove
      ? [
          {
            link: url('ExpenseApprovalsPage', { status: 'pending' }),
            name: intl.formatMessage(messages.expenseApprovalsBreadcrumb),
          },
          {
            name: intl.formatMessage(messages.pageTitle),
          },
        ]
      : [
          {
            link: url('ExpenseStatusPage', { status: 'pending' }),
            name: intl.formatMessage(messages.expenseStatusBreadcrumb),
          },
          {
            name: intl.formatMessage(messages.pageTitle),
          },
        ]
  ) satisfies IBreadcrumbsProps['crumbs']

  return (
    <Page
      pageTitle={intl.formatMessage(messages.pageTitle)}
      breadcrumbs={breadcrumbs}
    >
      <ExpenseView uuid={uuid} onPermissionsLoaded={handlePermissionsLoaded} />
    </Page>
  )
}
